import React, { useState } from "react";

import { clientUrl } from "../../constants/site-urls";

import ExampleList from "./example-list";

const ExamplePreview = () => {
  return (
    <div className="mx-auto max-w-7xl mt-12 pb-16 px-6 lg:px-8">
      <div>
        <h2 className="text-base font-semibold leading-7 text-emerald-500">
          Example & guide templates
        </h2>
        <p className="mt-2 max-w-2xl text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Learn how everything comes together with fully functional example
          extensions
        </p>
        <p className="mt-4 max-w-xl text-base leading-8 text-slate-600">
          Browse source code of fully functional example extensions including
          ones currently live in the Web Store with thousands of active users,
          as well as guide templates to demonstrate more advanced patterns such
          as error tracking
        </p>
        <a
          className="mt-4 inline-block font-semibold text-emerald-600 hover:text-emerald-700"
          href={`${clientUrl}/?ref=preview&type=example`}
        >
          View all examples & guide templates &rarr;
        </a>
      </div>
      <div className="mt-16">
        <ExampleList />
      </div>
    </div>
  );
};

export default ExamplePreview;
